import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export const NOTIF_TYPE_CONFIG = {
  mention:       { icon: AlternateEmailIcon, color: '#7c3aed', bg: '#f3e8ff', label: 'notifications.mentionedYou' },
  group_invite:  { icon: GroupAddIcon,       color: '#0891b2', bg: '#e0f7fa', label: 'notifications.invitedYouToGroup' },
  message:       { icon: ChatBubbleOutlineIcon, color: '#2563eb', bg: '#dbeafe', label: 'notifications.sentMessage' },
  task_assigned: { icon: AssignmentTurnedInIcon, color: '#d97706', bg: '#fef3c7', label: 'notifications.assignedTask' },
};

export function getNotifUrl(n) {
  switch (n.relatedType) {
    case 'post':    return `/posts#post-${encodeURIComponent(n.relatedId)}`;
    case 'group':   return `/groups/${encodeURIComponent(n.relatedId)}`;
    case 'task':    return '/planning';
    case 'message': return '/chat';
    default:        return n.relatedId ? `/posts#post-${encodeURIComponent(n.relatedId)}` : '/posts';
  }
}

export function timeAgo(dateStr, t) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return t('notifications.justNow', 'Just now');
  if (mins < 60) return t('notifications.minutesAgo', '{{m}} min ago', { m: mins });
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return t('notifications.hoursAgo', '{{h}}h ago', { h: hrs });
  const days = Math.floor(hrs / 24);
  if (days < 7) return t('notifications.daysAgo', '{{d}}d ago', { d: days });
  return new Date(dateStr).toLocaleDateString();
}
